module.exports = __webpack_public_path__ + "media/images/site-logo-a8bb5b0cbe9cff2158ea5f7945a43d1b.png";